var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{directives:[{name:"show",rawName:"v-show",value:(_vm.isLoaded),expression:"isLoaded"}],staticClass:"iframe-container",staticStyle:{"height":"100vh","width":"100vw"},attrs:{"allow":"fullscreen","src":_vm.launchURL,"allowfullscreen":"","webkitallowfullscreen":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }